document.addEventListener('DOMContentLoaded', function () {
  var cta = document.querySelector('.js-sticky-product-cta');

  if (!cta) return;

  var showOffset = window.innerHeight * 0.8;

  function toggleStickyCta() {
    if (window.scrollY > showOffset) {
      cta.classList.add('is-visible');
      cta.setAttribute('aria-hidden', 'false');
    } else {
      cta.classList.remove('is-visible');
      cta.setAttribute('aria-hidden', 'true');
    }
  }

  toggleStickyCta();

  window.addEventListener('scroll', toggleStickyCta, { passive: true });
});
